import Pagination from 'components/Pagination'
import { StyledTable } from 'components/TableStyles/TableStyles'
import ViewCollegeDetails from 'modules/Roles/Partials/ViewCollegeDetails/Partials/ViewStudentDrawer'
import React, { useEffect, useState } from 'react'

import AntdAvatar from 'components/Avatar'
import {
  FlexWrap,
  RowNumberData,
  Wrapper,
} from 'components/TableStyles/TableContentStyles/TableContentStyles'
import GreenStarIcon from 'components/icons/GreenStarIcon'
import CandidatesStatus from 'modules/Roles/ViewRole/CandidatesTable/CandidatesStatus'
import ViewActions from 'modules/Roles/ViewRole/CandidatesTable/ViewActions'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router'
import {
  RowNumberDriveAlignCenter,
  RowNumberDriveAlignCenterItem,
} from '../../../../../components/TableStyles/TableContentStyles/TableContentStyles'
import { permittedSubEvents } from '../../../../../utils/permissionsValidation'
import ExStudentFilter from '../ExStudentFilter'
const ExStudentTable = ({
  singleRoleData,
  getCandidateDetails,
  candidateDetails,
  viewRoleDetails = false,
  getInstitutesList,
  institutesList,
  setInstitutesList,
  getDegreesBasedOnRoles,
  rolesDegreeList,
  driveData,
  getAppliedCandidateListTrue,
  appliedCandidatesListTrue,
  setSelectedRows,
  selectedRows,
  setShortlistRows,
  setCandidateIds,
  getPromotion,
  promotionData,
}) => {
  let pageLimit = 10
  const params = useParams()
  const [sortBy, setSortBy] = useState('')
  const [orderBy, setOrderBy] = useState('')
  const [candidateLoading, setCandidateLoading] = useState(false)
  const [checkedKeys, setCheckedKeys] = useState([])
  const [searchValue, setSearchValue] = useState('')
  const [candidatesTableData, setCandidatesTableData] = useState({})
  const [pageNum, setPageNum] = useState(0)
  const [count, setCount] = useState(1)
  const [viewDrawer, setViewDrawer] = useState(false)
  const [candidateRating, setCandidateRating] = useState([])
  const [candidateStatus, setCandidateStatus] = useState([])
  const [checkedIds, setCheckedIds] = useState([])
  const [campusIds, setCampusIds] = useState([])
  const [gender, setGender] = useState('')
  const [instituteSearch, setInstituteSearch] = useState('')
  const [loading, setLoading] = useState(false)
  const [campusLoading, setCampusLoading] = useState(false)
  const [candidateFilterData, setCandidateFilterData] = useState({
    rating: '',
    status: '',
    degreeDepartment: '',
    collegeName: '',
    gender: '',
    degreekeys: '',
  })

  const handleSort = (page, search, filter) => {
    if (filter?.order) {
      let sort = filter?.order == 'ascend' ? 'asc' : 'desc'
      setSortBy(filter?.field)
      setOrderBy(sort)
    } else {
      setOrderBy('')
      setSortBy('')
    }
  }

  const studentDetailsAPI = async std_Id => {
    const { status } = await getCandidateDetails({
      studentId: std_Id,
      roleId: params?.jobId,
      setLoading: setCandidateLoading,
    })

    if (status >= 200 && status < 300) {
      setViewDrawer(true)
    }
  }

  const fetchCandidateData = async () => {
    let { data, status } = await getAppliedCandidateListTrue({
      roleId: params?.jobId,
      setLoading,
      searchValue,
      sortby: sortBy,
      orderby: orderBy,
      filterData: candidateFilterData,
      pageLimit: pageLimit,
      pageNum: pageNum,
    })
    if (status >= 200 && status < 300) {
      setCandidatesTableData(data?.data)
    }
    if (status >= 400) {
      setCandidatesTableData({})
    }
  }

  useEffect(() => {
    getDegreesBasedOnRoles({ jobId: params?.jobId })
  }, [params])

  useEffect(() => {
    setPageNum(0)
    setCount(prev => prev + 1)
  }, [candidateFilterData, searchValue])

  useEffect(() => {
    let getData
    if (searchValue) {
      getData = setTimeout(() => {
        fetchCandidateData()
      }, 500)
    } else {
      fetchCandidateData()
    }

    return () => clearTimeout(getData)
  }, [sortBy, orderBy, pageNum, count])

  useEffect(() => {
    const getData = setTimeout(() => {
      instituteSearch
        ? getInstitutesList({
            searchValue: instituteSearch,
            setLoading: setCampusLoading,
          })
        : setInstitutesList()
    }, 500)

    return () => clearTimeout(getData)
  }, [instituteSearch])

  const pastCourseDetails = student => {
    const formatEducation = education => {
      return `${education?.degree?.toLowerCase()} - ${education?.department?.toLowerCase()}`
    }
    if (Array.isArray(student?.educationProfile)) {
      return student?.educationProfile?.map(formatEducation)
    } else if (student?.educationProfile) {
      return formatEducation(student.educationProfile)
    } else {
      return null
    }
  }

  const rowSelection = {
    selectedRowKeys: selectedRows,

    onChange: (selectedRowKeys, selectedRows) => {
      const studentIds = selectedRows.map(candidate => candidate.student.id)
      setCandidateIds(studentIds)
      setSelectedRows(selectedRowKeys)
    },

    getCheckboxProps: candidate => {
      const isShortlisted =
        candidate?.driveRoleCandidateMap?.length &&
        candidate.driveRoleCandidateMap[0]?.status !== 'CANCELLED'
      return {
        disabled: isShortlisted,
      }
    },
  }
  useEffect(() => {
    if (selectedRows?.length > 0) {
      setShortlistRows(true)
    } else {
      setShortlistRows(false)
    }
  }, [selectedRows])
  const permission = useSelector(state => state?.auth?.permissions)
  const subEvents = permittedSubEvents(
    permission,
    'ROLES',
    'EXPERIENCED CANDIDATES'
  )

  const columns = [
    {
      title: 'candidate Name',
      dataIndex: 'firstName',
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      render: (_, { student }) => (
        <FlexWrap alignCenter gap="8px">
          <AntdAvatar
            src={student?.profileUrl}
            size={25}
            IconName={student?.firstName?.split('')[0]}
          />
          <RowNumberData>
            {student?.firstName?.length > 16
              ? student?.firstName?.substr(0, 16) + '...'
              : student?.firstName}
          </RowNumberData>
        </FlexWrap>
      ),
    },
    {
      title: 'Location',
      dataIndex: 'corrCity',
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      render: (_, { student }) => (
        <RowNumberData>
          {student?.studentPersonalProfile?.corrCity ??
            student?.studentPersonalProfile?.[0]?.corrCity}
        </RowNumberData>
      ),
    },
    {
      title: 'Deg & Department',
      dataIndex: 'degree',
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      width: 200,
      render: (_, { student }) => (
        <RowNumberData>{pastCourseDetails(student)}</RowNumberData>
      ),
    },
    {
      title: 'Specialization',
      dataIndex: 'specialisation',
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      width: 200,
      render: (_, { student }) => (
        <RowNumberData>
          {student?.educationProfile?.map((val, index) =>
            val?.specialisation ? (
              <span key={index + val?.specialisation}>
                {val.specialisation}
                {index < student.educationProfile.length - 1 && ', '}
              </span>
            ) : null
          )}
        </RowNumberData>
      ),
    },

    {
      title: 'Experience',
      dataIndex: 'experience',
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      align: 'center',
      render: (_, { student }) => {
        const { workExperience } = student

        const totalMonths = Math.round(workExperience * 12)
        const years = Math.floor(totalMonths / 12)
        const months = totalMonths % 12

        const experienceParts = []
        if (years > 0) {
          experienceParts.push(`${years} Yr${years > 1 ? 's' : ''}`)
        }
        if (months > 0) {
          experienceParts.push(`${months} Month${months > 1 ? 's' : ''}`)
        }
        return (
          <RowNumberDriveAlignCenter>
            {experienceParts.join(' ')} {}
          </RowNumberDriveAlignCenter>
        )
      },
    },

    {
      title: 'Score',
      dataIndex: 'rating',
      sorter: true,
      hidden: !singleRoleData?.isRankingActive,
      sortDirections: ['ascend', 'descend'],
      render: rating => (
        <FlexWrap gap="5px">
          <RowNumberDriveAlignCenter>
            {Number(rating)?.toFixed(2)}
          </RowNumberDriveAlignCenter>
          <AntdAvatar
            size={22}
            IconName={<GreenStarIcon />}
            background="none"
          />
        </FlexWrap>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'driveRoleCandidateMap',
      align: 'center',
      render: (_, { isSeened, driveRoleCandidateMap }) => (
        <RowNumberDriveAlignCenterItem>
          <CandidatesStatus
            status={driveRoleCandidateMap[0]?.status}
            isExpCandidate={true}
            isSeened={driveRoleCandidateMap?.length === 0 ? isSeened : false}
          />
        </RowNumberDriveAlignCenterItem>
      ),
    },

    {
      title: 'Action',
      hidden: !subEvents?.includes('VIEW'),
      render: (_, { student }) => (
        <ViewActions
          driveData={driveData}
          key={student?.id}
          student_id={student?.id}
          candidateLoading={candidateLoading}
          studentDetailsAPI={studentDetailsAPI}
          getPromotion={getPromotion}
          subEvents={subEvents}
        />
      ),
    },
  ].filter(item => !item.hidden)

  const onPageChange = value => {
    setPageNum(value)
  }

  return (
    <>
      <Wrapper>
        <ExStudentFilter
          singleRoleData={singleRoleData}
          appliedCandidatesList={candidatesTableData}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          candidateRating={candidateRating}
          setCandidateRating={setCandidateRating}
          candidateStatus={candidateStatus}
          setCandidateStatus={setCandidateStatus}
          gender={gender}
          setGender={setGender}
          instituteSearch={instituteSearch}
          setInstituteSearch={setInstituteSearch}
          degreeListData={rolesDegreeList}
          checkedKeys={checkedKeys}
          setCheckedKeys={setCheckedKeys}
          checkedIds={checkedIds}
          setCheckedIds={setCheckedIds}
          institutesList={institutesList}
          appliedCandidatesListTrue={appliedCandidatesListTrue}
          campusIds={campusIds}
          setCampusIds={setCampusIds}
          candidateFilterData={candidateFilterData}
          setCandidateFilterData={setCandidateFilterData}
          viewRoleDetails={viewRoleDetails}
        />
        <StyledTable
          columns={columns}
          pagination={false}
          dataSource={appliedCandidatesListTrue?.result}
          rowSelection={subEvents?.includes('SHORTLIST') ? rowSelection : false}
          rowKey={student => student?.student?.id}
          onChange={handleSort}
        />
        {candidatesTableData?.count > 0 && (
          <Pagination
            onChange={onPageChange}
            totalPages={candidatesTableData?.totalPage * 10}
            pageSize={pageLimit}
            current={pageNum || pageNum + 1}
          />
        )}
      </Wrapper>
      <ViewCollegeDetails
        viewDrawer={viewDrawer}
        setViewDrawer={setViewDrawer}
        singleStudentData={candidateDetails}
        promotionData={promotionData}
        loading={loading || campusLoading}
      />
    </>
  )
}

export default ExStudentTable
